import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'clients';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const clientsActions = { ...slice.actions, ...extraActions };
export const clientsReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        clients: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/user`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetClients`),
            { condition: (_, { getState }) => !Array.isArray(getState().clients.clients) }
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.clients = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.clients = action.payload;
            },
            [rejected]: (state, action) => {
                state.clients = { error: action.error };
            }
        };
    }
}
